import { render, staticRenderFns } from "./Diagnostic.vue?vue&type=template&id=385eda4c&scoped=true&"
import script from "./Diagnostic.vue?vue&type=script&lang=js&"
export * from "./Diagnostic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385eda4c",
  null
  
)

export default component.exports